// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2NCZ6","content":"styles_content__2a1fi","checkbox":"styles_checkbox__24wbV","checkboxLabel":"styles_checkboxLabel__2GCGL"};